import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { finishQuizRequested } from 'features/quizzes/actions';

export function* finishQuizSaga(action: ReturnType<typeof finishQuizRequested>) {
  yield call(SignalingSocket.send, { event: 'finishQuiz', data: action.payload });
}
